import {API, Endpoints} from "@brg/api";
import {CreateLinkTo} from "../constants/linkTo";

export const createVoting = async (isGameClosed: boolean, projectId: string, pollId: string, history: any, setIsWaiting: (val: boolean) => void) => {

    setIsWaiting(true);

    if (isGameClosed) {
        await API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/pools/CopyPollByProject')
            .post()
            .body({
                projectId: projectId,
            })
            .send()
            .then((r) => r.json())
            .then((r) => {
                if (r?.entityId) history.push(CreateLinkTo.projectEdit(r?.entityId))
            })
            .catch((err) => console.error(err));
        setIsWaiting(false);
        return
    }

    await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/pools/StartPoll')
        .post()
        .body({
            bestOfPollId: pollId,
        })
        .send()
        .then((r) => r.json())
        .catch((err) => console.error(err));
    setIsWaiting(false);

    history.push(CreateLinkTo.project(projectId))
};import {API, Endpoints} from "@brg/api";
import {CreateLinkTo} from "../constants/linkTo";

export const createVoting = async (isGameClosed: boolean, projectId: string, pollId: string, history: any, setIsWaiting: (val: boolean) => void) => {

    setIsWaiting(true);

    if (isGameClosed) {
        await API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/pools/CopyPollByProject')
            .post()
            .body({
                projectId: projectId,
            })
            .send()
            .then((r) => r.json())
            .then((r) => {
                if (r?.entityId) history.push(CreateLinkTo.projectEdit(r?.entityId))
            })
            .catch((err) => console.error(err));
        setIsWaiting(false);
        return
    }

    await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/pools/StartPoll')
        .post()
        .body({
            bestOfPollId: pollId,
        })
        .send()
        .then((r) => r.json())
        .catch((err) => console.error(err));
    setIsWaiting(false);

    history.push(CreateLinkTo.project(projectId))
};